module.exports = __webpack_public_path__ + "img/balli.fde51221.png";